const SINGLE_CYRILLIC_LETTER_AFTER_SPACE_REGEXP = /\s[а-яё](?=[^а-яё]|$)/gi;

/**
 * Переводит в верхний регистр одиночные буквы после пробела.
 *
 * Примеры:
 * - "корпус а" -> "корпус А"
 * - "литера б" -> "литера Б"
 */
export const uppercaseSingleLetters = (value: string) => {
  return value.replace(SINGLE_CYRILLIC_LETTER_AFTER_SPACE_REGEXP, (match) => match.toUpperCase());
};
